// 이폴더가 적절한지 모르겠으며 팀원들과 협의해야 함
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import ErrorHandler from '../Services/ErrorHandler/ErrorHandler';

// QueryClient 설정
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 탭 복귀 시 자동 재조회로 로컬 편집/업로드 행이 덮어씌워지는 것 방지
      refetchOnWindowFocus: false,
    },
  },
  // 조회할 때 쓰는거 GET
  queryCache: new QueryCache({
    onError: async (error) => {
      const { shouldShowDialog } = await ErrorHandler.handleError(error);
      if (shouldShowDialog) {
        window.location.assign('/');
      }
    },
  }),
  // 데이터 변경할 때 쓰는 거  POST, PUT, PATCH, DELETE
  mutationCache: new MutationCache({
    onError: async (error) => {
      const { shouldShowDialog } = await ErrorHandler.handleError(error);
      // 에러가 401인 경우 로그인 페이지로 이동
      if (shouldShowDialog) {
        window.location.assign('/');
      }
    },
  }),
});

export default function ReactQueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
